<template>
  <v-overlay
    :value="overlay"
    :z-index="40"
  >
  </v-overlay>
</template>

<script>
import CookieBotListener from "fincraft-lib-basics/src/mixins/CookieBotListener"

//TODO this component can be in lib basic and shared with blog
export default {
  name: "FinCookieDeclaration",
  mixins: [CookieBotListener],
  data(){
    return {
      overlay: false
    }
  },
  mounted() {
    if(window.CookiebotDialog){
      //in firefox: the initnal CookiebotOnDialogDisplay event is also fired to fast
      //we can set it true here because window.CookiebotDialog is not set if the dialog is not shown
      this.overlay = window.CookiebotDialog.DOM.style.display !== 'none'
      if(this.overlay){
        //firefox workarround: trigger resize, to recalculate cookiedialog dimensions
        window.dispatchEvent(new Event('resize'))
      }
    }
  },
  methods: {
    CookiebotOnDialogDisplay(){
      this.overlay=true
    },

    CookiebotOnChange() {
      this.overlay=false
    },
  }
}
</script>

<style lang="scss">
#CybotCookiebotDialogBodyContentText {
  & > p > a {
    display: inline-block;
  }
}
</style>
